export class ASCIITransformer
{
  private static _map:Map<string,string> = null;

  private static _createMap()
  {
    this._map = new Map<string,string>();

    this._add( ["Ä"], "A" );
    this._add( ["Ö"], "O" );
    this._add( ["Ü"], "U" );
    this._add( ["ß"], "b", false );

  }

  private static _add( chars:string[], replacement:string, toLowerCase:boolean = true )
  {
    for ( let i = 0; i < chars.length; i++ )
    {
      this._map.set( chars[ i ], replacement );

      if ( toLowerCase )
      {
        this._map.set( chars[ i ].toLowerCase(), replacement.toLowerCase() );
      }
    }    
  }

  static get map()
  {
    if ( ASCIITransformer._map === null )
    {
      this._createMap();
    }

    return ASCIITransformer._map;
  }
  
  static transformCharacter( char:string )
  {
    if ( ! ASCIITransformer.map.has( char ) )
    {
      return ASCIITransformer.map.get( " " ); 
    }

    return ASCIITransformer.map.get( char ); 
  }

}